module.exports = __webpack_public_path__ + "img/official-holidays-plans.1859d4c9.svg";